import React, { useState } from "react";
import Head from "../../../layout/head/Head";
import { useLocation, useNavigate } from "react-router";
import { useForm } from "react-hook-form";
import Content from "../../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../../components/Component";
import { Button, Form } from "reactstrap";
import MyInput from "../../../MyComp/UI/form/MyInput";
import MyEmail from "../../../MyComp/UI/form/MyEmail";
import MyMobile from "../../../MyComp/UI/form/MyMobile";
import MyDate from "../../../MyComp/UI/form/MyDate";
import MySelect from "../../../MyComp/UI/form/MySelect";
import ImageUpload from "../../../MyComp/UI/form/ImageUpload";
import MyTextArea from "../../../MyComp/UI/form/MyTextArea";
import moment from "moment";
import MyButton from "../../../MyComp/UI/form/MyButton";
import { StepHeader } from "./StepHeader";
import MyPAN from "../../../MyComp/UI/form/MyPAN";
import MyAadhaar from "../../../MyComp/UI/form/MyAadhaar";
import { doctorProfileRegistration } from "../../../api/doctor";
import { toast } from "react-toastify";
import useLogout from "../../../hooks/useLogout";

const StepOne = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useLogout();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    reset,
    setError,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      agreed: false,
      medical_qualification: null,
      qualificationDD: [],
      specializationDD: [],

      profile_image: null,
      profile_img: null,

      pan_image: null,
      pan_img: null,

      cert_image: null,
      cert_img: null,

      aadhaar_f_image: null,
      aadhaar_f_img: null,

      aadhaar_b_image: null,
      aadhaar_b_img: null,

      objectionKeys: [],
      approvedKeys: [],

      degree: [
        {
          certificate: null,
          certificate_url: null,
        },
      ],
      qualifications: [
        {
          degree_name: "",
          institution_name: "",
          year_of_passing: null,
        },
      ],
      experiences: [
        {
          organization: "",
          from_date: null,
          to_date: null,
          department_id: "",
          is_current: false,
          description: "",
        },
      ],
      mode: location?.state?.mode || "Add",
      actionType: null,
    },
  });
  const [mode, setMode] = useState(location?.state?.mode || "Add");
  const doctorId = location?.state?.doctorId||""
  const isLoading = watch("isLoading");
  const [imageOpen, setImageOpen] = useState(false);
  const handleImageOpenPreview = (row) => {
    const imageUrl = `${row?.image}`;
    setValue("image_preview", imageUrl);
    setImageOpen(true);
  };
  const onFormSubmit = (data) => {
    const formData = new FormData();
    formData.append("name", watch("name") || null);
    formData.append("doctorId", "");
    formData.append("email", watch("email") || null);
    formData.append("mobile", watch("mobile") || null);
    formData.append("dob", moment(watch("dob")).format("YYYY-MM-DD") || null);
    formData.append("gender", watch("gender")?.value || null);
    formData.append("description", watch("bio") || null);
    formData.append("pan_number", watch("pan_number") || null);
    formData.append("aadhaar_number", watch("aadhaar_number") || null);
    const metaImg = watch("profile_img");
    if (metaImg instanceof File) {
      formData.append("profile", metaImg);
    } else if (typeof metaImg === "string") {
      formData.append("profile", metaImg);
    }
    const panImg = watch("pan_img");
    if (panImg instanceof File) {
      formData.append("pan", panImg);
    } else if (typeof panImg === "string") {
      formData.append("pan", panImg);
    }
    const aadhaarFImg = watch("aadhaar_f_img");
    if (aadhaarFImg instanceof File) {
      formData.append("aadhaar_front", aadhaarFImg);
    } else if (typeof aadhaarFImg === "string") {
      formData.append("aadhaar_front", aadhaarFImg);
    }
    const aadhaarBImg = watch("aadhaar_b_img");
    if (aadhaarBImg instanceof File) {
      formData.append("aadhaar_back", aadhaarBImg);
    } else if (typeof aadhaarBImg === "string") {
      formData.append("aadhaar_back", aadhaarBImg);
    }

    if (mode == "Add") {
      doctorProfileRegistration(formData).then((res) => {
        if (res.data.status === true) { 
          navigate("/doctor-registration/professional-details",{ state: { mode: "Add" ,doctorId:res.data.data?.doctorId} });
          toast.success(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === false) {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      });
    }
  };
  return (
    <>
      <Head title={"Doctor Registration | Basic Details"} />
      <Content>
        <BlockHead size={"sm"}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Doctor Registration"}
              </BlockTitle>
            </BlockHeadContent>
              <BlockHeadContent>
                          <div className="">
                            <Button
                              color="primary"
                              outline
                              className={`  me-n1`}
                              onClick={() => {
                                navigate("/doctors");
                              }}
                            >
                              <Icon name={"arrow-left"} />
                            </Button>
                          </div>
                        </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <PreviewAltCard>
            <StepHeader current={1} />
            <Form onSubmit={handleSubmit(onFormSubmit)}>
              <Row className=" ">
                <div className="d-flex gap-5 py-3 mb-3">
                  {" "}
                  <h5>{"Basic Details"}</h5>
                </div>
                <Col md="3">
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Your Name"
                    name="name"
                    placeholder="Enter Your Name"
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col md="3">
                  <MyEmail
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Email Address"
                    name="email"
                    placeholder="Enter Email Address"
                    required
                    disabled={mode == "Approval"}
                  />
                </Col>
                <Col md="3" className={``}>
                  <MyMobile
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Mobile"}
                    name={"mobile"}
                    placeholder={"Enter mobile"}
                    required
                    disabled={mode == "Approval"}
                    readOnly={mode == "Edit"}
                  />
                </Col>
                <Col md="3" className={``}>
                  <MyDate
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Date of Birth"}
                    name={"dob"}
                    placeholder={"Enter date of birth"}
                    required
                    max={moment().subtract(20, "years").toDate()}
                    min={moment().subtract(90, "years").toDate()}
                    disabled={mode == "Approval"}
                  />
                </Col>

                <Col md={3}>
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Gender"}
                    name={"gender"}
                    placeholder={"Select gender"}
                    required
                    options={[
                      { value: "male", label: "Male" },
                      { value: "female", label: "Female" },
                      { value: "other", label: "Other" },
                    ]}
                    disabled={mode == "Approval"}
                  />
                </Col>

           
                <Col md="3">
                  <MyPAN
                    title="PAN Number"
                    name="pan_number"
                    watch={watch}
                    register={register}
                    setValue={setValue}
                    errors={errors}
                    required
                    isPan
                    placeholder="ABCDE1234F"
                  />
                </Col>
                <Col md="3">
                  <MyAadhaar
                    title="Aadhaar Card Number"
                    name="aadhaar_number"
                    register={register}
                    setValue={setValue}
                    errors={errors}
                  />
                </Col>
                <Col md="3">
                  <ImageUpload
                    getValues={getValues}
                    design={4}
                    id="profile_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"Profile Image"}
                    errors={errors}
                    register={register}
                    image={"profile_img"}
                    image_url={"profile_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    required
                    approve={mode === "Approval" ? true : false}
                    size={400}
                  />
                </Col>
                <Col md="3">
                  <ImageUpload
                    getValues={getValues}
                    design={4}
                    id="aadhaar_f_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"AADHAAR Front"}
                    errors={errors}
                    register={register}
                    image={"aadhaar_f_img"}
                    image_url={"aadhaar_f_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    required
                    validateDoc
                    approve={mode === "Approval" ? true : false}
                    size={2048}
                  />
                </Col>
                <Col md="3">
                  <ImageUpload
                    getValues={getValues}
                    design={4}
                    id="aadhaar_b_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"AADHAAR Back"}
                    errors={errors}
                    register={register}
                    image={"aadhaar_b_img"}
                    image_url={"aadhaar_b_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    required
                    validateDoc
                    approve={mode === "Approval" ? true : false}
                    size={2048}
                  />
                </Col>
                <Col md="3">
                  <ImageUpload
                    getValues={getValues}
                    design={4}
                    id="pan_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"PAN Image"}
                    errors={errors}
                    register={register}
                    image={"pan_img"}
                    image_url={"pan_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    required
                    validateDoc
                    approve={mode === "Approval" ? true : false}
                    size={2048}
                  />
                </Col>
                     <Col md="12" className={``}>
                  <MyTextArea
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Bio/Description"}
                    name={"bio"}
                    placeholder={"Tell us something about you"}
                    // required
                    // min={25}
                    // max={500}
                    cols={2}
                    row={2}
                    disabled={mode == "Approval"}
                  />
                </Col>
              </Row>
              {(mode == "Add" || mode == "Edit") && (
                <Row>
                  <Col md="12" className={``}>
                    <div className="form-group d-flex justify-content-end" style={{ marginTop: "31px" }}>
                      <MyButton isLoading={isLoading} mode={mode} />
                    </div>
                  </Col>
                </Row>
              )}
            </Form>
          </PreviewAltCard>
        </Block>
      </Content>
    </>
  );
};

export default StepOne;
